import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { TextWithLinkCell } from '~/components/common';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

type TypeDeliveryAgencyOrdersUploadFailDetail = TypeDeliveryAgencyOrdersUploadResult['failDetails'][number];

const getDeliveryAgencyOrderExcelUploadFailColumnDefs = () => {
  const columnDefs: ColDef<TypeDeliveryAgencyOrdersUploadFailDetail>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'rowNums',
      headerName: '실패 대상',
      width: 160,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        textOverflow: 'clip',
        whiteSpace: 'normal',
      },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOrdersUploadFailDetail,
        TypeDeliveryAgencyOrdersUploadFailDetail['rowNums']
      >) => value?.map((num: number) => `${num}행`).join(', ') ?? '-',
    },
    {
      field: 'message',
      headerName: '실패 사유',
      minWidth: 506,
      flex: 1,
      cellRenderer: TextWithLinkCell,
      cellStyle: { paddingTop: '9px' },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOrderExcelUploadFailColumnDefs;
